import Vue from 'vue'
import Router from 'vue-router'
import VueI18n from 'vue-i18n'

import _PageWrapperNav from 'sections/_PageWrapperNav'
import Guide from 'sections/Guide/_main'
import MobileDetect from 'sections/MobileDetect/_main'
// import NowTv from 'sections/NowTv/_main'
import RadioPlayer from 'sections/RadioPlayer/_main'
import Error404 from 'sections/Error/404/_main'
import Error503 from 'sections/Error/503/_main'
import deviceDetector from 'helpers/device/deviceDetector'
import mobileDetector from 'helpers/device/mobileDetector'

Vue.use(Router)
Vue.use(VueI18n)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/mobile', name: 'Mobile', component: MobileDetect, meta: {keyTitle: 'general_navigation_home'} },
    {
      path: '/',
      component: _PageWrapperNav,
      children: [
        { path: '', name: 'Guide', component: Guide, meta: { keyTitle: 'general_navigation_guide' } },
        // { path: '/now-on-tv', name: 'NowTv', component: NowTv, meta: { keyTitle: 'general_navigation_guide' } },
        { path: 'radio-stations', name: 'RadioPlayer', component: RadioPlayer, meta: { keyTitle: 'general_navigation_guide' } },
        { path: '503', name: 'Error503', component: Error503 },
        { path: '404', name: 'Error404', component: Error404 },
        { path: '*', component: Error404 }
      ],
      beforeEnter: (to, from, next) => {
        // Mobile detector
        let deviceType = deviceDetector.deviceType

        if (mobileDetector.isMobile(deviceType)) {
          next({path: '/mobile'})
          return false
        }

        next()
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js